import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var UnprocessableEntityError = /*#__PURE__*/function (_Error) {
  function UnprocessableEntityError(reason) {
    var _this;
    var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UnprocessableEntityError);
    _this = _callSuper(this, UnprocessableEntityError, ["UnprocessableEntityError"]);
    _defineProperty(_this, "name", "UnprocessableEntityError");
    _defineProperty(_this, "type", 'api error');
    _defineProperty(_this, "statusCode", 422);
    _this.message = "".concat(_this.name, " ").concat(JSON.stringify(extraData));
    _this.trace = reason;
    return _this;
  }
  _inherits(UnprocessableEntityError, _Error);
  return _createClass(UnprocessableEntityError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { UnprocessableEntityError as default };